import { useEffect, useState } from "react";
import ContentHeader from "../components/ContentHeader";
import AddPage from "./components/AddPage";
import SchedulesTable from "./components/SchedulesTable/SchedulesTable";
import FilterForm from "./components/FilterForm";
import Button, { SIZE } from "components/Button";
import userService from "services/user.service";
import styles from "./Schedules.module.scss";
import ScheduleEditingPage from "./components/ScheduleEditingPage";
import Message from "./components/Message";

const Schedules = ({ isLoggedIn }) => {
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [scheduleOptions, setScheduleOptions] = useState([]);
  const [schedulesList, setScheduleList] = useState([]);
  const [rawSchedulesList, setRawScheduleList] = useState([]);
  const [currentScreen, setCurrentScreen] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [breaksList, setBreaksList] = useState([]);
  const [isRefresh, setIsRefresh] = useState(false);

  const handleOnSubmit = (selected) => {
    setShowButton(true);
    // No filter selected => show ALL schedules. Always keep this an ARRAY so the
    // table renders consistently (an empty object silently broke row rendering).
    let schedulesDataFiltered = rawSchedulesList;
    if (selected.length > 0) {
      schedulesDataFiltered = rawSchedulesList.filter((item) =>
        selected.some((secondItem) => secondItem.value === item.id),
      );
    }
    setScheduleList(schedulesDataFiltered);
  };

  useEffect(() => {
    isLoggedIn &&
      userService.getSchedulesList().then(
        (response) => {
          const scheduleListData = response?.data;
          const breaksList = scheduleListData.map((schedule) => {
            return {
              title: schedule.breaks,
              value: schedule.id,
            };
          });
          const options = scheduleListData.map((schedule) => {
            return {
              label: schedule.name,
              value: schedule.id,
            };
          });

          setScheduleOptions(options);
          setBreaksList(breaksList);

          function reformatBreaks(breakItem) {
            const minBreak = parseInt(
              breakItem.split("Min: ")[1].split(" mins")[0],
            );
            const maxBreak = parseInt(
              breakItem.split("Max: ")[1].split(" mins")[0],
            );
            return `${minBreak}-${maxBreak}`;
          }

          let newScheduleListData = scheduleListData.map((schedule) => {
            const formattedString = (string) => {
              const lines = string.split("\n").map((line) => line.trim());
              const result = lines
                .map((line) => {
                  if (line.startsWith("Start early:")) {
                    return `start: early ${line.split(":")[1].trim()}`;
                  } else if (line.startsWith("Start late:")) {
                    return `late: ${line.split(":")[1].trim()}`;
                  } else if (line.startsWith("End early:")) {
                    return `end: early ${line.split(":")[1].trim()}`;
                  } else if (line.startsWith("End late:")) {
                    return `late: ${line.split(":")[1].trim()}`;
                  } else return null;
                })
                .filter(Boolean);
              return result.join(", ");
            };
            return {
              id: schedule.id,
              name: schedule.name,
              shifts: schedule.shifts.reduce((result, shift) => {
                const day = shift.split(",")[0].toLowerCase();
                const time = shift.split(",")[1].trim().split(" - ");
                const startTime = time[0];
                const endTime = time[1];
                const formattedTime = `${startTime}-${endTime}`;
                result[day] = formattedTime;
                return result;
              }, {}),
              breakDuration: reformatBreaks(schedule["breaks"]),
              work_time_forecasting: formattedString(
                schedule.work_time_forecasting,
              ),
            };
          });
          setRawScheduleList(newScheduleListData);
          setScheduleList(newScheduleListData);
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setScheduleOptions(_content);
        },
      );
  }, [isLoggedIn, currentScreen, isRefresh]);

  const handleClick = () => {
    setCurrentScreen("add");
  };

  return (
    <div>
      {currentScreen === "" && (
        <>
          <Button
            type="submit"
            size={SIZE.MIDDLE}
            className={styles.add_button}
            onClick={() => handleClick()}
          >
            Add Schedule
          </Button>
          <ContentHeader title="Schedules" className={styles.contentheader} />

          <div className={styles.filter}>
            <FilterForm
              isLoggedIn={isLoggedIn}
              handleOnSubmit={handleOnSubmit}
              showButton={showButton}
              scheduleOptions={scheduleOptions}
            />
          </div>
          <div className={styles.content}>
            <SchedulesTable
              schedulesData={schedulesList}
              setCurrentScreen={setCurrentScreen}
              setEditingId={setEditingId}
              setIsRefresh={setIsRefresh}
              setMessage={setMessage}
              setShowMessage={setShowMessage}
            />
          </div>
        </>
      )}
      {showMessage && <Message text={message} showMessage={showMessage} />}
      {currentScreen === "add" && (
        <AddPage
          setCurrentScreen={setCurrentScreen}
          breaksList={breaksList}
          currentScreen={currentScreen}
          schedulesList={schedulesList}
          setShowMessage={setShowMessage}
          setMessage={setMessage}
        />
      )}
      {currentScreen === "edit" && (
        <ScheduleEditingPage
          setCurrentScreen={setCurrentScreen}
          editingId={editingId}
          schedulesData={schedulesList}
          breaksList={breaksList}
          currentScreen={currentScreen}
          setShowMessage={setShowMessage}
          schedulesList={schedulesList}
          setMessage={setMessage}
        />
      )}
    </div>
  );
};

export default Schedules;
